(async function () {
    "use strict";

    const newsFilters = document.querySelectorAll(".newsFilter");

    function addChangeEvents(newsFilter) {
        addBtnClick(newsFilter, "type");
        addBtnClick(newsFilter, "topic");
        addBtnClick(newsFilter, "location");

        const clearButton = newsFilter.querySelector(".clear button");
        clearButton?.addEventListener("click", () => clearSelections(newsFilter));

        const filterButton = newsFilter.querySelector(".filterbutton");
        filterButton?.addEventListener("click", () => {
            newsFilter.querySelector(".options")?.classList.toggle("active");
        });
    }

    function addBtnClick(newsFilter, btnClass) {
        const buttons = newsFilter.querySelectorAll(`.btn-${btnClass}`);
        buttons.forEach(button => {
            button.addEventListener("click", (e) => {
                selectButton(newsFilter, btnClass, e.target.innerText, () => populateResults(newsFilter));
            });
        });
    }

    function filterIsSelected(newsFilter, btnClass) {
        return newsFilter.querySelector(`.btn-${btnClass}.active`) !== null;
    }

    function setFilterSelections(newsFilter) {
        const counter = newsFilter.querySelector(".filterbutton .counter");
        const clear = newsFilter.querySelector(".clear");
        if (!counter || !clear) return;

        let numSelections = 0;
        if (filterIsSelected(newsFilter, "type")) numSelections++;
        if (filterIsSelected(newsFilter, "topic")) numSelections++;
        if (filterIsSelected(newsFilter, "location")) numSelections++;

        if (numSelections > 0) {
            counter.innerText = String(numSelections);
            counter.classList.remove("hidden");
            clear.classList.remove("hidden");
        } else {
            counter.classList.add("hidden");
            clear.classList.add("hidden");
        }
    }

    async function selectButton(newsFilter, btnClass, value, callback) {
        const buttons = newsFilter.querySelectorAll(`.btn-${btnClass}`);
        buttons.forEach(button => {
            if (value && button.innerText === value) {
                button.classList.toggle("active");
            } else {
                button.classList.remove("active");
            }
        });

        if (typeof callback === "function") {
            await callback();
        }
    }

    function getButtonValue(newsFilter, btnClass) {
        return newsFilter.querySelector(`.btn-${btnClass}.active`)?.innerText || "";
    }

    async function clearSelections(newsFilter) {
        selectButton(newsFilter, "type", null);
        selectButton(newsFilter, "topic", null);
        selectButton(newsFilter, "location", null);
        await populateResults(newsFilter);
    }

    function isNumeric(value) {
        return !isNaN(parseFloat(value)) && isFinite(value);
    }

    async function populateResults(newsFilter) {
        setFilterSelections(newsFilter);

        const itemsContainer = newsFilter.querySelector(".itemscontainer");
        const itemsList = newsFilter.querySelector(".list");
        const notFound = newsFilter.querySelector(".notfound");

        itemsContainer?.classList.add("hidden");
        itemsList?.classList.add("hidden");
        notFound?.classList.add("hidden");

        // Clear existing non-template items
        newsFilter.querySelectorAll(".items .result:not(.template), .list .result:not(.template)")
            .forEach(item => item.remove());

        const postData = {
            NewsRootId: newsFilter.dataset.newsrootid,
            DITId: newsFilter.dataset.ditid,
            FeatureId: isNumeric(newsFilter.dataset.featureid) ? newsFilter.dataset.featureid : 0,
            Topic: getButtonValue(newsFilter, "topic"),
            Type: getButtonValue(newsFilter, "type"),
            Location: getButtonValue(newsFilter, "location")
        };

        try {
            const response = await fetch(`/api/nfapi/getitems`, {
                method: "POST",
                cache: "no-store",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(postData)
            });

            if (!response.ok) throw new Error("Failed to fetch news items");
            const data = await response.json();

            const items = data?.items || [];
            if (items.length === 0) {
                notFound?.classList.remove("hidden");
            }
            if (items.length > 6) {
                itemsList?.classList.remove("hidden");
            }

            populateData(newsFilter, data);
            itemsContainer?.classList.remove("hidden");
        } catch (err) {
            console.error("Error populating results:", err);
        }
    }

    function populateTeaser(newsFilter, itemElement, item) {
        const hilite = newsFilter.dataset.hilite;
        const hiliteEl = itemElement.querySelector(".hilite");

        if (hiliteEl) {
            if (item.newsType === hilite) {
                hiliteEl.innerText = hilite;
                hiliteEl.classList.remove("hidden");
            } else {
                hiliteEl.classList.add("hidden");
            }
        }

        const teaserEl = itemElement.querySelector(".teaser");
        if (!teaserEl) return;

        teaserEl.replaceChildren();
        teaserEl.classList.add("hidden");

        if (item.teaserImage?.url) {
            const teaserimageEl = document.createElement("img");
            const divider = item.teaserImage.url.includes("?") ? "&" : "?";
            teaserimageEl.src = `${item.teaserImage.url}${divider}width=400&height=267&mode=crop`;
            teaserimageEl.alt = item.teaserImage.name || "";
            teaserEl.appendChild(teaserimageEl);
            teaserEl.classList.remove("hidden");
        }
    }

    function populateDate(itemElement, item) {
        const catContainer = itemElement.querySelector(".cat");
        if (!catContainer) return;

        const parts = [];

        if (item.articleDate) {
            const dateSpan = document.createElement("span");
            dateSpan.className = "date";
            dateSpan.innerText = item.articleDate;
            parts.push(dateSpan);
        }

        if (item.newsTopic) {
            const topicSpan = document.createElement("span");
            topicSpan.className = "topic";
            topicSpan.innerText = item.newsTopic;
            parts.push(topicSpan);
        }

        if (parts.length === 0) return;

        const wrapper = document.createElement("div");
        parts.forEach((part, index) => {
            if (index > 0) {
                const divider = document.createElement("span");
                divider.className = "divider";
                divider.innerText = "|";
                wrapper.appendChild(divider);
            }
            wrapper.appendChild(part);
        });

        catContainer.appendChild(wrapper);
    }

    function populateData(newsFilter, data) {
        const items = data?.items || [];
        if (items.length === 0) return;

        // 1. First 6 items into primary layout grid
        const itemsContainer = newsFilter.querySelector(".items");
        const itemTemplate = itemsContainer?.querySelector(".result.template");

        if (itemsContainer && itemTemplate) {
            items.slice(0, 6).forEach(item => {
                const itemElement = itemTemplate.cloneNode(true);
                itemElement.classList.remove("template");
                itemElement.dataset.id = item.id;
                itemElement.setAttribute("href", item.url || "#");

                const heading = itemElement.querySelector(".heading");
                if (heading) heading.textContent = item.name;

                const summary = itemElement.querySelector(".summary");
                if (summary) summary.textContent = item.summary;

                populateTeaser(newsFilter, itemElement, item);
                populateDate(itemElement, item);
                itemsContainer.appendChild(itemElement);
            });
        }

        // 2. Additional items into sub-list layout
        const listContainer = newsFilter.querySelector(".list");
        const listTemplate = listContainer?.querySelector(".result.template");

        if (listContainer && listTemplate && items.length > 6) {
            items.slice(6).forEach(item => {
                const itemElement = listTemplate.cloneNode(true);
                itemElement.classList.remove("template");
                itemElement.dataset.id = item.id;
                itemElement.setAttribute("href", item.url || "#");

                const heading = itemElement.querySelector(".heading");
                if (heading) heading.textContent = item.name;

                populateDate(itemElement, item);
                listContainer.appendChild(itemElement);
            });
        }
    }

    // Initialize all news filter instances on page load
    for (const newsFilter of newsFilters) {
        if (!newsFilter.dataset.newsrootid) continue;
        addChangeEvents(newsFilter);
        await populateResults(newsFilter);
    }
})();